import React, { useState } from 'react'
import { IoMdArrowRoundBack } from 'react-icons/io';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { formatDate } from "../../../helper/index";
import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import { DispositionReportViewApi } from '../../Api';
import { RenderPaginationButtons } from '../../../Components/Paginations';

function MonitorDispositionStatusReportsView() {
    const navigate = useNavigate();
    const { id }: any = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState<any>([]);

    const [info, setInfo] = useState<{
        count: number;
        current_page: number;
        limit: number;
        total_page: number;
    }>();
    const [page, setPage] = useState(1);


    const Report = useQuery({
        queryKey: ["Disposition-Report-View-Api", id],
        queryFn: DispositionReportViewApi,
        onSuccess: (resp: AxiosResponse) => {
            setIsLoading(false);
            setData(resp.data || []);
            setPage(resp.data?.info?.current_page || 1);
            setInfo(resp?.data?.info);
        },
        enabled: !!id,
    });

    const handlePageChange = (page: number) => {
        if (page > 0 && page <= (info?.total_page || 1)) {
            setPage(page);
        }
    };

    return (
        <>
            <section className="content">
                <div className="container-fluid">
                    <div className="card mt-4 shadow-sm border rounded">
                        <div className="card-header bg-white p-3 d-flex justify-content-md-between">
                            <h2 className="w-100 mb-md-0 fs-3">View Disposition</h2>
                            <Link to={""} className="text-decoration-none">
                                <button
                                    onClick={() => navigate(-1)}
                                    className="btn btn-info text-white d-flex align-items-center fw-semibold"
                                >
                                    <IoMdArrowRoundBack /> Back
                                </button>
                            </Link>
                        </div>

                        <div className="card-body px-0 py-0">
                            <div className="table-responsive">
                                <table className="table mb-0 table-bordered">
                                    <tbody>
                                        {isLoading ? (
                                            <tr>
                                                <td colSpan={2} height={100}>
                                                    <div className="text-center">
                                                        <div className="loader"></div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : !data?.data ? (
                                            <tr>
                                                <td colSpan={2} className="text-center">
                                                    No Data Found
                                                </td>
                                            </tr>
                                        ) : (
                                            <>
                                                {/* <tr>
                                                    <th
                                                        className="p-3 fw-bold"
                                                        style={{ width: 150 }}
                                                    >
                                                        Name
                                                    </th>
                                                    <td className="p-3">{data?.data?.user_name || "-"}</td>
                                                </tr> */}
                                                <tr>
                                                    <th
                                                        className="p-3 fw-bold"
                                                        style={{ width: 150 }}
                                                    >
                                                        Campaign Name
                                                    </th>
                                                    <td className="p-3">{data?.data?.campaign_name || "-"}</td>
                                                </tr>
                                                <tr>
                                                    <th
                                                        className="p-3 fw-bold"
                                                        style={{ width: 150 }}
                                                    >
                                                        Phone Number
                                                    </th>
                                                    <td className="p-3">{data?.data?.number || "-"}</td>
                                                </tr>
                                                <tr>
                                                    <th
                                                        className="p-3 fw-bold"
                                                        style={{ width: 150 }}
                                                    >
                                                        Status
                                                    </th>
                                                    <td className="p-3">{data?.data?.status || "-"}</td>
                                                </tr>
                                                <tr>
                                                    <th
                                                        className="p-3 fw-bold"
                                                        style={{ width: 150 }}
                                                    >
                                                        Created At
                                                    </th>
                                                    <td className="p-3">{formatDate(data?.data?.created_at) || "-"}</td>
                                                </tr>
                                                <tr>
                                                    <th
                                                        className="p-3 fw-bold"
                                                        style={{ width: 150 }}
                                                    >
                                                        Updated At
                                                    </th>
                                                    <td className='p-3'>{formatDate(data?.data?.updated_at) || "-"}</td>
                                                </tr>
                                            </>
                                        )}
                                    </tbody>
                                </table>

                                <h4 className='mt-4 mb-2 ps-3'>Disposition Logs</h4>
                                <table className="table table-hover table-bordered text-nowrap">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '20px' }}>SR No</th>
                                            <th style={{ width: 200, minWidth: 200 }}>By Updated Name</th>
                                            <th style={{ width: 200, minWidth: 200 }}>By Updated Email</th>
                                            <th style={{ width: 200, minWidth: 200 }}>By Updated Number</th>
                                            <th style={{ width: 200, minWidth: 200 }}>Status</th>
                                            <th style={{ width: 200, minWidth: 200 }}>Created At</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {data.Logs && data.Logs[0] ? (
                                            data.Logs.map((item: any, i: number) => (
                                                <tr>
                                                    <td>{i + 1 + (page - 1) * 10}</td>
                                                    <td>{item?.UserName || " - "}</td>
                                                    <td>{item?.UserEmail || " - "}</td>
                                                    <td>{item?.Records?.number || " - "}</td>
                                                    <td>{item?.Records?.status || " - "}</td>
                                                    <td>{formatDate(item?.createdAt) || " - "}</td>
                                                </tr>
                                            ))
                                        ) : !Report.isFetching ? (
                                            <tr>
                                                <td colSpan={6} height={50}>
                                                    <div className="text-center">
                                                        <p className="mb-0 fs-5 fw-semibold">
                                                            No data found
                                                        </p>
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : null}
                                    </tbody>
                                </table>
                                {Report.isFetching ? (
                                    <center className="mb-3">
                                        <i
                                            className=" my-2 fa loader"
                                            style={{ fontSize: "30px", color: "black" }}
                                        ></i>
                                    </center>
                                ) : null}
                                {info && info.total_page ? (
                                    <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                                        <RenderPaginationButtons
                                            info={info}
                                            currentPage={page}
                                            handlePageChange={handlePageChange}
                                        />
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default MonitorDispositionStatusReportsView;
